<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-delete"></i> 物资报废</span>
      </div>

      <el-tabs v-model="activeTab">
        <el-tab-pane label="固定物资" name="fixed">
          <FixedTab />
        </el-tab-pane>
        <el-tab-pane label="日常消耗" name="daily">
          <DailyTab />
        </el-tab-pane>
        <el-tab-pane label="低值易耗" name="consumables">
          <ConsumableTab />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import FixedTab from "./fixTab.vue";
import ConsumableTab from "./consumableTab.vue";
import DailyTab from "./dailyTab.vue";

export default {
  name: "ScrapRecord",
  components: { FixedTab, ConsumableTab, DailyTab },
  data() {
    return {
      activeTab: "fixed",
    };
  },
};
</script>

<style scoped>
.app-container {
  
}
.el-card {
  margin-bottom: 20px;
}
</style>
